import React, { useEffect, useState, useContext } from 'react';
import '../../App.css';
import { useHistory } from 'react-router-dom';
import {
  Button,
  Checkbox,
  Grid,
  Popover,
  Modal,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  FormControl,
  Box
} from '@material-ui/core';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import FolderOpenIcon from '@material-ui/icons/FolderOpen';
import NoteAddIcon from '@material-ui/icons/NoteAdd';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import DeleteIcon from '@material-ui/icons/Delete';
import CreateIcon from '@material-ui/icons/Create';
import ShareIcon from '@material-ui/icons/Share';
import PeopleAltIcon from '@material-ui/icons/PeopleAlt';
import HelpIcon from '@material-ui/icons/Help';
import { PersonAdd } from '@material-ui/icons';
import {
  TFolderPicture,
  TPicture
} from '../../types/cloudStorage/CloudFileList';
import { AddModal } from './AddModal';
import { PictureDetailField } from './PictureDetailModal';
import { FolderShareField } from '../parts/cloudStorage/FolderShareField';
import { PictureFolderEditField } from '../parts/cloudStorage/EditFolderName';
import { DeleteAlertModal } from '../parts/cloudStorage/DeleteAlertModal';
import { FolderAuthorityModal } from '../parts/cloudStorage/FolderAuthorityModal';
import { FileList } from './FileList';
import { checkResData } from '../../utils/common';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { getSharePictureGuestList } from '../../apicalls/cloud/sharePicture';
import type { TCurrentGuest } from '../../types/CloudStorageModal';
import { getThumbnail } from '../../apicalls/cloudFile';
import _ from 'lodash';
import { useSnackbar } from 'notistack';
import { CustomTooltip } from '../tooltip/CustomTooltip';
import { tooltipContents } from '../tooltip/Const';
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { AuthInfoContext } from '../../AuthContextProvider';
import { ROLE, DAILY_REPORT_FOLDER_NAME } from '../../const/Const';
import { BasicSelect } from '../parts/input/BasicSelect';
import PaginationComponent from '../../components/PaginationComponent';

import {
  getAuthorizedOutsidePartner,
  updatePictureFolderAuthority
} from '../../apicalls/cloud/cloudPicture';

type Tprops = {
  folder: TFolderPicture;
  getValues: any;
  getFolderPictureList: any;
  handleSelectedPictures: (picture: TPicture) => void;
  addAllSelectedPictures: (picture: TPicture[]) => void;
  removeAllSelectedPictures: (picture: TPicture[]) => void;
  selectedPictures: TPicture[];
  setSelectedPictures: (pictures: TPicture[]) => void;
  onDeleteFolder: (folderId: number) => void;
};

//写真一覧用フォルダリスト
export const FolderField: React.FC<Tprops> = (props: Tprops) => {
  const {
    folder,
    getValues,
    getFolderPictureList,
    handleSelectedPictures,
    addAllSelectedPictures,
    removeAllSelectedPictures,
    selectedPictures,
    setSelectedPictures,
    onDeleteFolder
  } = props;

  // 親から渡ってくる
  const folderId: number = folder.id;
  const folderName: string = folder.name;
  const constructId: number = folder.construct_id;
  const constructName: string = folder.construct_name;
  const pictureList: TPicture[] = folder.pictures;

  const history: any = useHistory();
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();
  const [authInfo, setAuthInfo] = useContext(AuthInfoContext);

  // モーダルオープン
  const [modalOpen, setModalOpen] = React.useState(false);
  // 詳細データ取得用
  const [pictureId, setPictureId] = useState<number>();
  // 詳細モーダル開閉用
  const [openDetailModal, setOpenDetailModal] = useState(false);
  // フォルダ編集モーダル開閉用
  const [openEditFolderModal, setOpenEditFolderModal] =
    useState<boolean>(false);
  // 閲覧権限編集モーダル
  const [openPictureFolderAuthorityModal, setOpenPictureFolderAuthorityModal] =
    React.useState(false);
  // フォルダ共有モーダル開閉用
  const [openShareFolderModal, setOpenShareFolderModal] =
    useState<boolean>(false);
  // 削除アラートモーダル
  const [openAlertModal, setOpenAlertModal] = React.useState(false);
  // アコーディオン制御用
  const [openAccordion, setOpenAccordion] = React.useState<boolean>(false);

  const [openCnt, setOpenCnt] = React.useState<number>(0);

  const [value, setValue] = useState<boolean>(false);

  const [anchorEl, setAnchorEl] = useState(null);

  // 現在共有済みの共有先リスト
  const [currentGuestList, setCurrentGuestList] = useState<TCurrentGuest[]>([]);
  // 共有先が存在するかのフラグ
  const [isGuest, setIsGuest] = useState<boolean>(false);

  const [pictData, setPictData] = useState<TPicture[]>(pictureList);

  // ボタンのサイズ調整
  const theme = useTheme();
  const isWideScreen = useMediaQuery(theme.breakpoints.up('md'));

  // ページネーション
  const [displayLimit, setDisplayLimit] = useState<number>(30);
  const [pageCount, setPageCount] = useState(1);
  const [currentPage, setCurrentPage] = useState(
    history.location.state?.currentPage || 1
  );

  const paginatedPictures = pictData.slice(
    (currentPage - 1) * displayLimit,
    currentPage * displayLimit
  );

  useEffect(() => {
    setPageCount(Math.ceil(pictData.length / displayLimit));
  }, [pictData, displayLimit]);

  useEffect(() => {
    setCurrentPage(1);
  }, [displayLimit]);

  // 追加モーダルが閉められたタイミングでサムネイルを取得
  useEffect(() => {
    if (!modalOpen) {
      (async () => {
        await getDispThumbnail();
      })();
    }
  }, [modalOpen]);

  useEffect(() => {
    if (openCnt != 0) {
      (async () => {
        await getDispThumbnail();
      })();
    }
  }, [pictureList.length]);

  useEffect(() => {
    // console.log(openCnt)
    if (openCnt == 1) {
      (async () => {
        await getDispThumbnail();
      })();
    }
  }, [openCnt]);

  const getDispThumbnail = async () => {
    const upCount = pictureList.length - pictData.length;

    if (upCount >= 0) {
      for (let i = 0; i < pictureList.length; i++) {
        let index = pictData.findIndex(u => u.id === pictureList[i].id);
        if (index == -1 || !pictData[index].src) {
          await getThumbnail(pictureList[i].id).then(data => {
            if (data.data) {
              const image_data = data.data.replace(/^.*,/, '');
              setPictData((preSetting: TPicture[]) => {
                const newPreSetting: TPicture[] = _.cloneDeep(preSetting);
                if (index === -1) {
                  newPreSetting.push({
                    ...pictureList[i],
                    src: `data:${data.file_format};base64,${image_data}`
                  });
                } else {
                  newPreSetting[index] = {
                    ...newPreSetting[index],
                    src: `data:${data.file_format};base64,${image_data}`
                  };
                }
                return newPreSetting;
              });
            }
          });
        }
      }
    } else {
      if (pictureList.length == 0) {
        setPictData([]);
      } else {
        for (let i = 0; i < pictData.length; i++) {
          let index = pictureList.findIndex(u => u.id === pictData[i].id);
          if (index == -1) {
            setPictData((preSetting: TPicture[]) => {
              preSetting.splice(i, 1);
              const newPreSetting: TPicture[] = _.cloneDeep(preSetting);
              return newPreSetting;
            });
          }
        }
      }
    }
  };

  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  const onCheck = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const checked: boolean = event.target.checked;
    if (paginatedPictures && paginatedPictures.length > 0) {
      if (checked) {
        addAllSelectedPictures(paginatedPictures);
      } else {
        removeAllSelectedPictures(paginatedPictures);
      }
    }
    setValue(checked);
  };

  const onOpenAccordionAddPict = () => {
    setOpenCnt(openCnt + 1);
    setOpenAccordion(true);
  };

  const onOpenAccordion = () => {
    setOpenCnt(openCnt + 1);
    if (openAccordion) {
      setOpenAccordion(false);
    } else {
      setOpenAccordion(true);
    }
  };

  // 現在の共有先リストを取得
  const getGuestList = () => {
    getSharePictureGuestList(folderId)
      .then(resData => {
        if (resData && resData.share_list) {
          checkResData(resData, enqueueSnackbar).then(resData => {
            setCurrentGuestList(resData.share_list);
            setIsGuest(resData.share_list.length > 0);
          });
        } else {
          enqueueSnackbar('共有先リストの取得に失敗しました', {
            variant: 'error'
          });
        }
      })
      .catch(error => {
        enqueueSnackbar('エラーが発生しました: ' + error.message, {
          variant: 'error'
        });
      });
  };

  useEffect(() => getGuestList(), [folderId]);

  const onOpenAccordionModal = () => {
    setOpenAccordion(true);
  };

  return (
    <>
      <AddModal
        modalOpen={modalOpen}
        setModalOpen={setModalOpen}
        constructId={getValues('construct_id').value}
        pictureFolderId={folderId}
        getFolderPictureList={getFolderPictureList}
        onOpenAccordionModal={onOpenAccordionModal}
      />

      {pictData && pictData.length === 0 ? (
        <div
          style={{
            padding: '12px 16px',
            display: 'flex',
            backgroundColor: '#fff',
            boxShadow:
              '0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%)'
          }}
        >
          <div
            style={{ display: 'flex', flexDirection: 'column', width: '100%' }}
          >
            <div
              style={{
                display: 'flex',
                flexWrap: isWideScreen ? 'nowrap' : 'wrap',
                width: '100%',
                justifyContent: 'space-between',
                marginBottom: 36
              }}
            >
              <div style={{ width: isWideScreen ? 'none' : '100%' }}>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    fontSize: '20px'
                  }}
                >
                  <FolderOpenIcon style={{ marginRight: '8px' }} />
                  <span style={{ fontWeight: 'bold', marginRight: 4 }}>
                    {folderName}
                  </span>
                  {isGuest && <PeopleAltIcon />}

                  <MoreVertIcon
                    style={{ cursor: 'pointer', marginLeft: 12 }}
                    aria-describedby={id}
                    onClick={event => {
                      event.stopPropagation();
                      handleClick(event);
                    }}
                  />
                  <Popover
                    id={id}
                    open={open}
                    onClick={event => {
                      event.stopPropagation();
                    }}
                    anchorEl={anchorEl}
                    onClose={handleClose}
                    anchorOrigin={{
                      vertical: 'center',
                      horizontal: 'right'
                    }}
                    transformOrigin={{
                      vertical: 'top',
                      horizontal: 'left'
                    }}
                  >
                    <div>
                      {authInfo?.role != ROLE['OUTSIDE_PARTNER'] && (
                        <>
                          {folderName !== DAILY_REPORT_FOLDER_NAME && (
                            <div
                              className={classes.popoverButton}
                              onClick={event => {
                                event.stopPropagation();
                                setOpenEditFolderModal(true);
                              }}
                            >
                              <CreateIcon />
                              フォルダ編集
                            </div>
                          )}
                          <div
                            className={classes.popoverButton}
                            onClick={event => {
                              event.stopPropagation();
                              setOpenAlertModal(true);
                            }}
                          >
                            <DeleteIcon />
                            フォルダ削除
                          </div>
                          <div
                            className={classes.popoverButton}
                            onClick={() =>
                              setOpenPictureFolderAuthorityModal(true)
                            }
                          >
                            <div style={{ marginRight: 8 }}>
                              <PersonAdd />
                            </div>
                            公開する社外パートナー
                          </div>
                        </>
                      )}
                      <div
                        className={classes.popoverButton}
                        onClick={event => {
                          event.stopPropagation();
                          setOpenShareFolderModal(true);
                        }}
                      >
                        <ShareIcon />
                        フォルダを外部共有
                        <CustomTooltip
                          title={tooltipContents.SharePictureLink}
                          placement='right'
                          interactive
                        >
                          <HelpIcon color='action' style={{ marginLeft: 8 }} />
                        </CustomTooltip>
                      </div>
                    </div>
                  </Popover>

                  <DeleteAlertModal
                    title={'フォルダ'}
                    message={folderName}
                    fileCount={folder.file_count}
                    func={() => onDeleteFolder(folderId)}
                    openAlertModal={openAlertModal}
                    setOpenAlertModal={setOpenAlertModal}
                  />
                </div>
                <div style={{ marginLeft: '12px', color: 'gray' }}>
                  {constructName}
                </div>
              </div>

              <div
                style={{
                  display: 'flex',
                  justifyContent: 'end',
                  alignItems: 'center',
                  width: '100%'
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    flexDirection: isWideScreen ? 'row' : 'column'
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'end',
                      alignItems: 'center'
                    }}
                  >
                    <div
                      style={{
                        display: 'flex',
                        paddingRight: 10,
                        marginRight: 14,
                        borderRight: isWideScreen
                          ? '1px solid #cfcfcf'
                          : 'none',
                        fontSize: isWideScreen ? '1em' : '0.8em'
                      }}
                    >
                      <div>登録数（{folder.file_count}件）</div>
                    </div>
                  </div>

                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'end',
                      alignItems: 'center'
                    }}
                  >
                    <Button
                      style={{
                        backgroundColor: '#007dff',
                        marginRight: 10
                      }}
                      onClick={event => {
                        event.stopPropagation();
                        setModalOpen(true);
                      }}
                      variant='contained'
                      color='secondary'
                    >
                      <NoteAddIcon />
                      <span style={{ marginLeft: 4 }}>写真を追加</span>
                    </Button>
                  </div>
                </div>
              </div>
            </div>
            <div>フォルダに写真がありません</div>
          </div>
        </div>
      ) : (
        <Accordion expanded={openAccordion} onChange={onOpenAccordion}>
          <AccordionSummary aria-controls='panel1a-content' id='panel1a-header'>
            <div
              style={{
                display: 'flex',
                flexWrap: isWideScreen ? 'nowrap' : 'wrap',
                width: '100%',
                justifyContent: 'space-between'
              }}
            >
              <div style={{ width: isWideScreen ? 'none' : '100%' }}>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    fontSize: '20px'
                  }}
                >
                  <FolderOpenIcon style={{ marginRight: '8px' }} />
                  <span style={{ fontWeight: 'bold', marginRight: 4 }}>
                    {folderName}
                  </span>
                  {isGuest && <PeopleAltIcon />}

                  <MoreVertIcon
                    style={{ cursor: 'pointer', marginLeft: 12 }}
                    aria-describedby={id}
                    onClick={event => {
                      event.stopPropagation();
                      handleClick(event);
                    }}
                  />
                  <Popover
                    id={id}
                    open={open}
                    onClick={event => {
                      event.stopPropagation();
                    }}
                    anchorEl={anchorEl}
                    onClose={handleClose}
                    anchorOrigin={{
                      vertical: 'center',
                      horizontal: 'right'
                    }}
                    transformOrigin={{
                      vertical: 'top',
                      horizontal: 'left'
                    }}
                  >
                    <div>
                      {authInfo?.role != ROLE['OUTSIDE_PARTNER'] && (
                        <>
                          {folderName !== DAILY_REPORT_FOLDER_NAME && (
                            <div
                              className={classes.popoverButton}
                              onClick={event => {
                                event.stopPropagation();
                                setOpenEditFolderModal(true);
                              }}
                            >
                              <CreateIcon />
                              フォルダ編集
                            </div>
                          )}
                          <div
                            className={classes.popoverButton}
                            onClick={event => {
                              event.stopPropagation();
                              setOpenAlertModal(true);
                            }}
                          >
                            <DeleteIcon />
                            フォルダ削除
                          </div>
                          <div
                            className={classes.popoverButton}
                            onClick={() =>
                              setOpenPictureFolderAuthorityModal(true)
                            }
                          >
                            <div style={{ marginRight: 8 }}>
                              <PersonAdd />
                            </div>
                            公開する社外パートナー
                          </div>
                        </>
                      )}
                      <div
                        className={classes.popoverButton}
                        onClick={event => {
                          event.stopPropagation();
                          setOpenShareFolderModal(true);
                        }}
                      >
                        <ShareIcon />
                        フォルダを外部共有
                        <CustomTooltip
                          title={tooltipContents.SharePictureLink}
                          placement='right'
                          interactive
                        >
                          <HelpIcon color='action' style={{ marginLeft: 8 }} />
                        </CustomTooltip>
                      </div>
                    </div>
                  </Popover>

                  <DeleteAlertModal
                    title={'フォルダ'}
                    message={folderName}
                    fileCount={folder.file_count}
                    func={() => onDeleteFolder(folderId)}
                    openAlertModal={openAlertModal}
                    setOpenAlertModal={setOpenAlertModal}
                  />
                </div>
                <div style={{ marginLeft: '12px', color: 'gray' }}>
                  {constructName}
                </div>
              </div>

              <div
                style={{
                  display: 'flex',
                  justifyContent: 'end',
                  alignItems: 'center',
                  width: '100%'
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    flexDirection: isWideScreen ? 'row' : 'column'
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'end',
                      alignItems: 'center'
                    }}
                  >
                    {openAccordion && (
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          paddingRight: 10,
                          marginRight: 14,
                          borderRight: '1px solid #cfcfcf',
                          fontSize: isWideScreen ? '1em' : '0.8em'
                        }}
                      >
                        <div style={{ paddingLeft: 5 }}>
                          <FormControl className={classes.formControl}>
                            <BasicSelect
                              className={'select-div'}
                              value={displayLimit}
                              onChange={e => {
                                setDisplayLimit(parseInt(e.target.value));
                                setCurrentPage(1);
                                setSelectedPictures([]);
                                setValue(false);
                              }}
                              onClick={event => event.stopPropagation()}
                              inputProps={{ 'aria-label': 'age' }}
                              disableUnderline
                            >
                              <option value={30}>30件</option>
                              <option value={50}>50件</option>
                              <option value={100}>100件</option>
                            </BasicSelect>
                          </FormControl>
                        </div>
                        <Checkbox
                          checked={value}
                          onClick={event => event.stopPropagation()}
                          onChange={onCheck}
                          color='default'
                        />
                        ページ内全選択
                      </div>
                    )}
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        paddingRight: 10,
                        marginRight: 14,
                        borderRight: isWideScreen
                          ? '1px solid #cfcfcf'
                          : 'none',
                        fontSize: isWideScreen ? '1em' : '0.8em'
                      }}
                    >
                      <div>登録数（{folder.file_count}件）</div>
                      <div>
                        <ExpandMoreIcon onClick={onOpenAccordion} />
                      </div>
                    </div>
                  </div>

                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'end',
                      alignItems: 'center'
                    }}
                  >
                    <Button
                      style={{
                        backgroundColor: '#007dff',
                        marginRight: 10
                      }}
                      onClick={event => {
                        event.stopPropagation();
                        setModalOpen(true);
                      }}
                      variant='contained'
                      color='secondary'
                    >
                      <NoteAddIcon />
                      <span style={{ marginLeft: 4 }}>写真を追加</span>
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </AccordionSummary>
          <div style={{ width: '100%' }}>
            <AccordionDetails>
              {openCnt > 0 && (
                <Grid container spacing={4} style={{ margin: 'auto' }}>
                  {paginatedPictures.map((picture: TPicture, index: number) => (
                    <FileList
                      key={picture.id}
                      picture={picture}
                      handleSelectedPictures={handleSelectedPictures}
                      setOpenDetailModal={setOpenDetailModal}
                      setPictureId={setPictureId}
                      openDetailModal={openDetailModal}
                      selectedPictures={selectedPictures}
                      openAccordion={openAccordion}
                    />
                  ))}
                </Grid>
              )}
            </AccordionDetails>
            <Box className={classes.pagenationContainer}>
              <PaginationComponent
                page={currentPage}
                pageCount={pageCount}
                setCurrentPage={(page: number) => {
                  setCurrentPage(page);
                  setSelectedPictures([]);
                  setValue(false);
                }}
              />
            </Box>
          </div>
        </Accordion>
      )}

      {/* 写真詳細表示モーダル */}
      <Modal
        open={openDetailModal}
        onClose={() => setOpenDetailModal(false)}
        aria-labelledby='simple-modal-title'
        aria-describedby='simple-modal-description'
        className={classes.container}
      >
        <PictureDetailField
          pictureId={pictureId}
          folderName={folderName}
          getFolderPictureList={getFolderPictureList}
          openDetailModal={openDetailModal}
          setOpenDetailModal={setOpenDetailModal}
          pictureList={pictData.map(p => p.id)}
          currentIndex={pictData.findIndex(p => p.id === pictureId)}
          setCurrentIndex={(index: number) => {
            setPictureId(pictData[index].id);
          }}
        />
      </Modal>
      {/* フォルダ共有モーダル */}
      <Modal
        open={openShareFolderModal}
        onClose={() => setOpenShareFolderModal(false)}
        aria-labelledby='simple-modal-title'
        aria-describedby='simple-modal-description'
        className={classes.container}
      >
        <FolderShareField
          folderId={folderId}
          folderName={folderName}
          constructId={constructId}
          setOpenShareFolderModal={setOpenShareFolderModal}
          currentGuestList={currentGuestList}
          getGuestList={getGuestList}
        />
      </Modal>
      {/* フォルダ編集モーダル */}
      <Modal
        open={openEditFolderModal}
        onClose={() => setOpenEditFolderModal(false)}
        aria-labelledby='simple-modal-title'
        aria-describedby='simple-modal-description'
        className={classes.container}
      >
        <PictureFolderEditField
          folderId={folderId}
          folderName={folderName}
          openEditFolderModal={openEditFolderModal}
          setOpenEditFolderModal={setOpenEditFolderModal}
          getFolderPictureList={getFolderPictureList}
        />
      </Modal>
      {/* 閲覧権限編集モーダル*/}
      <Modal
        open={openPictureFolderAuthorityModal}
        className={classes.container}
      >
        <FolderAuthorityModal
          constructId={constructId}
          folderId={folderId}
          folderName={folderName}
          setOpenFileAuthorityModal={setOpenPictureFolderAuthorityModal}
          getAuthorizedOutsidePartner={getAuthorizedOutsidePartner}
          updateFolderAuthority={updatePictureFolderAuthority}
        />
      </Modal>
    </>
  );
};

const useStyles = makeStyles(() =>
  createStyles({
    formControl: {
      minWidth: 120,
      backgroundColor: '#FFFFFF'
    },
    formControl1: {
      minWidth: 120,
      height: 30,
      borderRadius: 5,
      borderWidth: 1,
      paddingLeft: 5
    },
    main: {
      minWidth: 700
    },
    table: {
      backgroundColor: `#999999 !important`,
      color: '#FFFFFF',
      padding: 10,
      fontWeight: 'bold'
    },
    input: {
      borderColor: '#CCCCCC',
      padding: 5,
      margin: 10
    },
    table1: {
      padding: 8
    },
    container: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: 15
    },
    popoverButton: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'start',
      cursor: 'pointer',
      borderBottom: '1px solid rgb(245, 245, 245)',
      padding: '20px 30px'
    },
    pagenationContainer: {
      display: 'flex',
      justifyContent: 'center',
      marginTop: 10,
      marginBottom: 30
    },
    listContainer: {
      padding: 15,
      backgroundColor: '#FFFFFF',
      borderRadius: 5
    }
  })
);
